<template lang="pug">

    //- div.container-loading(v-if="!criteriaListIsReady")
    //-     div.search-wrapper(v-if="!isCclone")
    //-         div.searchbar.stripe.long-stripe
    //-         div.l-flex-row--rev
    //-             div.searchfilter.stripe.small-stripe
    //-     div.content
    //-         div.stripe.medium-stripe.title
    //-         div.stripe.small-stripe.category
    //-         div.stripe.small-stripe.category
    //-         div.stripe.small-stripe.category
    //-     div.content(v-if="!isCclone")
    //-         div.stripe.medium-stripe.title
    //-         div.stripe.small-stripe.category
    //-         div.stripe.small-stripe.category
    //-         div.stripe.small-stripe.category
    //-     div.content(v-if="!isCclone")
    //-         div.stripe.medium-stripe.title
    //-         div.stripe.small-stripe.category
    //-         div.stripe.small-stripe.category
    //-         div.stripe.small-stripe.category

    div.criteria-main
        //- SEARCH
        div.search-criteria-wrapper(v-if="!isCclone")
            input.search-criteria(
                :class="{'isFocus':searchValue!==''}"
                placeholder="Search criterion"
                v-model="searchValue"
                @keyup.esc="resetSearch()"
                @keyup.enter="launchSearch()")
            svg-icon.search-reset(name='close' size='small' @click.native="resetSearch()" v-if="searchValue!==''")
            div.search-filter
                | Filter on :
                select.search-targets(v-model="searchTarget")
                    option(v-for="item in searchTargets", :key="item.value" :value="item.value") {{ item.label }}


        //- RESULT LIST
        div.search-result-wrapper.scrollbar.is-scrollable(v-if="mode === 'search'")
            div.no-results(v-if="!showResultList") No results found
            div.category(
                v-else
                v-for="(criteria, criteriaLabel) in searchResultsList" :key="criteriaLabel"
            )

                div.category-header
                    div.category-label {{ formSearchResultDataTypeLabel(criteriaLabel) }}
                    div.counter {{ criteria.length }}

                //- @TODO : utiliser le compo Tree 🤪
                div.tree-view

                    div.tree-item(v-for="(criterion, index) in criteria" :key="index")

                        div.tree-node(
                            v-if="index < 5 || fullList[criteriaLabel]" :class="[{'tree-node__tp': showId(criterion, criteriaLabel) || hasSmartSegments(criterion)}, {'tree-node__btm': hasTags(criterion) || criterion.ancestors !== undefined}]"
                            @click="addCriterionToFormula(criterion)")

                            div.node-icon
                                div.node-icon__default

                            div.tree-node__info
                                div.l-flex-row.tree-node__top-info(
                                    v-if="showId(criterion, criteriaLabel) || hasSmartSegments(criterion)")
                                    div.tree-node__id(v-if="showId(criterion, criteriaLabel)") {{ criterionId(criterion) }}
                                    svg-icon.tree-node__smartsegment(v-if="hasSmartSegments(criterion) && showFrequency" name='period' size='small')

                                div.tree-node__label(:title="criterion.label") {{ criterion.label }}

                                div.tree-node__btm-info(v-if="hasTags(criterion) || criterion.ancestors !== undefined")
                                    //- Path
                                    //- @TODO faire un module pour afficher le chemin cliquable 🐹
                                    //- ul.l-flex-row.criterion-path(v-if="criterion.ancestors || criterion.ancestors !== []")
                                    //-     li.criterion-path-item(v-for="ancestor in criterion.ancestors" :key="ancestor.id") {{ ancestor.label }}
                                    div.criterion-path(
                                        v-if="criterion.ancestors !== undefined"
                                        :title="criterionPath(criterion)") ↳ {{ criterionPath(criterion) }}
                                    //- Tags
                                    div.criterion-taglist(v-if="hasTags(criterion)")
                                        span.criterion-tag(
                                            v-for="(tag, index) of criterion.tags" :key="tag.id" v-if="index < 3 || displayAllTags(criterion.jsonKey.name)"
                                            @click.stop="launchSearch(tag.label)")
                                            span.tag-label(:title="tag.label") {{ tag.label }}

                                        template(v-if="criterion.tags.length > 3")
                                            button.btn-toogle-tag.btn-nude(
                                                v-if="displayAllTags(criterion.jsonKey.name)"
                                                @click.stop="toggleTagsFullList(criterion.jsonKey.name, false)") less
                                            button.btn-toogle-tag.btn-nude(
                                                v-else
                                                @click.stop="toggleTagsFullList(criterion.jsonKey.name, true)") more

                div.wrapper-show-more(v-if="criteria.length > 5")
                    div.btn-show-more(v-if="!fullList[criteriaLabel]" @click="toggleFullList(criteriaLabel)") show more
                    div.btn-show-more(v-else-if="fullList[criteriaLabel]" @click="toggleFullList(criteriaLabel)") show less

        //- CRITERIA
        div.wrapper-criteria-list(v-else-if="mode === 'selection'" :class="scrollbarClass")
            div.criteria-tree(v-if="showCriterion")
                //- BREADCRUMBS
                div.breadcrumb.l-flex-row.l-align-center
                    svg-icon.breadcrumb-path-root(
                        name='home' size='small'
                        @click.native="toggleShowCriterion")
                    div.l-flex-row.breadcrumb-path
                        div.breadcrumb-path-item(
                            @click.stop="toggleShowCriterion"
                            :title="upperfirstLabel(headCriteriaBreadcrumb)"
                        ) {{ upperfirstLabel(headCriteriaBreadcrumb) }}
                        div.breadcrumb-path-item(
                            @click="clickMidBreadcrumb"
                            :title="upperfirstLabel(middleCriteriaBreadcrumb)"
                        ) {{ upperfirstLabel(middleCriteriaBreadcrumb) }}
                        div.breadcrumb-path-item(
                            v-if="nodeType === 'hierarchy'"
                            :title="upperfirstLabel(lastCriteriaBreadcrumb)"
                        ) {{ upperfirstLabel(lastCriteriaBreadcrumb) }}

                //- TREE
                div.criteria-tree-container.scrollbar.is-scrollable.is-horizontally-scrollable(v-if="showCriterion")
                    Tree(
                        :key="nodeType"
                        :nodes="treeNode"
                        :nodeType="nodeType"
                        :nodeSubType="criterionSubType"
                        :isCcloneEvent="isCcloneEvent"
                        :isCcloneFirstParty="isCcloneFirstParty"
                        :firstPartySelection="firstPartySelection"
                        :ccloneHistory="ccloneHistory"
                        :storeFirstPartySelectAll="storeFirstPartySelectAll"
                        :showSelectAll="true"
                        :launchSearch="launchSearch"
                        :areFoldedNodes="areFoldedNodes"
                        :criteriaBreadcrumb="criteriaBreadcrumb"
                        @foldNodes="areFoldedNodes = false"
                    )

            //- Categories
            div.criteria-categories(v-else)
                div.category-list(v-for="(criteria, key) in _criteriaList" :key="key")
                    div.category(v-for="(category, categoryLabel, index) in criteria" :key="index")
                        div.category-label {{ upperfirstLabel(categoryLabel) }}
                        div.category-item(v-for="(criterionValue, criterionLabel) in category" :key="criterionLabel" @click.stop="displayTreeNode(criterionValue)") {{ formCriterionLabel(criterionLabel, categoryLabel, criterionValue.type) }}

</template>

<script>
import { DATA_TYPES, MEDIA_CONVERSION_TYPE, MEDIA_CAMPAIGN_TYPE } from '@/utils/constants'

//avoid repeating namespace for each store action/mutation/getter/state
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'

import Tree from '@/components/common/Tree.vue'

import { isNil, upperFirst, isEmpty, includes, head, last, find, join, get } from 'lodash'

export default {
    name: 'CriteriaList',
    components: { Tree },
    props: {
        // eslint-disable-next-line
        criteriaList: { type: Array, required: false },
        ccloneHistory: { type: Object, required: false, default: () => ({}) },
        isCcloneEvent: { type: Boolean, required: false },
        isCcloneFirstParty: { type: Boolean, required: false },
        firstPartyHistory: { type: Object, required: false, default: () => ({}) }
    },

    data() {
        return {
            displayIds: ['media', 'customTaxonomies', 'audience', 'georadar'],
            showCriterion: false,
            searchValue: '',
            searchResultsList: {},
            searchTargets: [
                { label: 'Label', value: 'label' },
                { label: 'Id', value: 'id' },
                { label: 'Tag', value: 'tag' }
            ],
            searchTarget: 'label',
            mode: 'selection',
            criterionSubType: null,
            fullList: null,
            expandedCriteria: {},
            isTagSearch: false,
            areFoldedNodes: false
        }
    },

    watch: {
        searchValue: {
            handler: function(newValue) {
                if (newValue === '') {
                    this.mode = 'selection'
                    this.fullList = this.setDefaultFullList()
                }
            }
        },
        mode: {
            handler: function(newValue) {
                if (newValue === 'selection') this.searchResultsList = {}
            }
        },
        dataTypes: {
            handler: function(newValue, oldValue) {
                if (newValue !== oldValue) this.fullList = this.setDefaultFullList()
            }
        },
        searchTarget: {
            handler: function(newValue, oldValue) {
                this.isTagSearch = newValue !== oldValue && newValue === 'tag'
                if (this.searchValue !== '' && newValue !== oldValue && !this.isTagSearch) {
                    this.launchSearch()
                }
            }
        },
        criteriaBreadcrumb: {
            handler() {
                const selection = this.firstPartyHistory?.selection
                if (selection) {
                    this.resetSelectedFirstPartyOnClose({
                        firstPartySelection: selection,
                        firstPartySelectAll: { hierarchy: false }
                    })
                }
            }
        }
    },

    computed: {
        // Call to state
        ...mapState('ui/builder', {
            menuCriteriaType: state => state.menuCriteriaType,
            focusedBox: state => state.focusedBox
        }),
        ...mapState('ui/cclone', {
            ccloneCriteriaTypes: state => state.criteriaTypes,
            eventType: state => state.eventType,
            firstPartySelection: state => state.firstPartySelection,
            storeFirstPartySelectAll: state => state.firstPartySelectAll
        }),
        ...mapState('data/settings', {
            showFrequency: state => state.general.frequency
        }),
        // Call to getters
        ...mapGetters('ui/builder', ['getTreeNode', 'getCriteriaPath', 'getSearchResults', 'getNavigation', 'criteriaListIsReady']),
        ...mapGetters('data/customTaxonomies', ['getWamCustomTaxoLabelByType']),
        ...mapGetters('account', ['getDataTypes']),
        dataTypes() {
            return this.getDataTypes
        },
        _criteriaList() {
            if (!isNil(this.criteriaList)) {
                for (const criteriaList of this.criteriaList) {
                    for (const criteriaType in criteriaList) {
                        for (const criteriaCategory in criteriaList[criteriaType]) {
                            if (
                                !criteriaList[criteriaType][criteriaCategory].list.length ||
                                (criteriaList[criteriaType][criteriaCategory].type === 'media' && criteriaList[criteriaType][criteriaCategory].list.length < 5)
                            ) {
                                delete criteriaList[criteriaType][criteriaCategory]
                            }
                        }
                    }
                }
                return this.criteriaList
            } else {
                return this.getNavigation()
            }
        },
        isCclone() {
            return this.isCcloneEvent || this.isCcloneFirstParty
        },
        //search results WITH data
        showResultList() {
            return !isEmpty(this.searchResultsList)
        },
        treeNode() {
            const tree = this.getTreeNode({ jsonKeyName: null, criterion: this.nodeType, criterionSubType: this.criterionSubType })
            return !this.showCriterion ? null : tree
        },
        nodeType() {
            return this.isCcloneEvent ? this.ccloneCriteriaTypes[this.eventType].current : this.menuCriteriaType
        },
        // Breadcrumb
        criteriaBreadcrumb() {
            return this.getCriteriaPath({
                menuCriteriaType: this.nodeType,
                secondPartyCriteria: this.menuCriteriaType === 'secondParty' || this.menuCriteriaType === 'hierarchy' ? this.criterionSubType : null
            })
        },
        headCriteriaBreadcrumb() {
            return head(this.criteriaBreadcrumb)
        },
        middleCriteriaBreadcrumb() {
            return this.criteriaBreadcrumb[1]
        },
        lastCriteriaBreadcrumb() {
            return last(this.criteriaBreadcrumb)
        },
        searchCategory() {
            if (this.searchTarget === 'label') return 'all'
            if (this.searchTarget === 'tag') return ['georadar', 'audience']
            else if (this.searchTarget === 'id') return ['customTaxonomies', 'media', 'georadar', 'audience', 'sharing']
            return ''
        },
        displayFullDataBase() {
            return this.isCcloneEvent && this.eventType === 'third'
        },
        full_criteriaList() {
            return this.displayFullDataBase ? [{ database: { 'full database': { list: [], isSelectable: true } } }] : this._criteriaList
        },
        scrollbarClass() {
            return this.showCriterion ? '' : 'scrollbar is-scrollable'
        }
    },

    methods: {
        // Call to mutations
        ...mapMutations('ui/builder', ['setCriterion', 'resetExpandedNodesIds', 'setDisabledFormulaBox']),
        ...mapMutations('ui/cclone', ['setCriteriaType', 'resetSelectedFirstPartyOnClose']),
        // Call to actions
        ...mapActions('ui/builder', ['addCriterionInBox']),

        clickMidBreadcrumb() {
            if (this.nodeType === 'customTaxonomies' || this.nodeType === 'hierarchy') {
                const type = this.criterionSubType === 'sharing' ? 'taxonomies' : 'customTaxonomies'
                if (this.isCcloneEvent) {
                    this.setCriteriaType({ eventType: this.eventType, criteriaType: type, history: 'current' })
                    this.showCriterion = true
                } else {
                    this.setCriterion({ type, name: null })
                }
            }
        },

        setDefaultFullList() {
            let _fullDataList = {}
            for (const dataType of this.dataTypes) {
                _fullDataList = {
                    ..._fullDataList,
                    [dataType]: false
                }
            }
            return _fullDataList
        },
        displayTreeNode(node) {
            if (!this.showCriterion) {
                this.criterionSubType = node.subType ? node.subType : null
                if (this.isCcloneEvent) {
                    this.setCriteriaType({ eventType: this.eventType, criteriaType: node.type, history: 'current' })
                    this.showCriterion = true
                } else {
                    this.setCriterion({ type: node.type, name: node.label })
                    this.showCriterion = true
                }
            }
        },
        toggleShowCriterion() {
            this.showCriterion = false
            this.resetExpandedNodesIds()
            if (!this.isCclone) {
                this.setCriterion({ type: null })
            }
        },
        upperfirstLabel(label) {
            if (label === 'browser') return 'Browsers'
            if (label === 'device') return 'Devices'
            if (label === 'os') return 'Operating Systems'
            if (label === 'isp') return 'Internet Service Providers'
            if (label === 'customTaxonomies') return 'Taxonomies'
            return upperFirst(label)
        },
        formCriterionLabel(criterionLabel, category, type) {
            if (category !== 'customTaxonomies' || criterionLabel === 'media') return this.upperfirstLabel(criterionLabel)
            return this.getWamCustomTaxoLabelByType({ type })
        },
        formSearchResultDataTypeLabel(type) {
            if (find(DATA_TYPES, dt => dt === type) || type === 'marketPlace' || type === 'sharing') return this.upperfirstLabel(type)
            return this.getWamCustomTaxoLabelByType({ type })
        },
        addCriterionToFormula(criterion) {
            this.setDisabledFormulaBox({ boxIndex: this.focusedBox.index, boxType: this.focusedBox.type, isDisabled: false })
            this.addCriterionInBox({
                criterion: criterion,
                nodeType: 'self'
            })
        },
        launchSearch(tag) {
            if (this.searchValue.trim() === '') {
                this.fullList = this.setDefaultFullList()
                return
            }

            this.mode = 'search'
            if (tag) {
                this.isTagSearch = true
                this.searchValue = tag
                this.searchTarget = 'tag'
            }
            this.searchResultsList = this.getSearchResults({
                searchPattern: this.searchValue.trim(),
                category: this.searchCategory,
                type: this.searchTarget,
                setFirstCategoryToDisplay: this.showCriterion
            })
        },
        resetSearch() {
            this.isTagSearch = false
            this.mode = 'selection'
            this.searchValue = ''
        },
        hasTags(criterion) {
            return !isEmpty(criterion.tags)
        },
        toggleTagsFullList(nodeId, status) {
            if (status) {
                this.expandedCriteria = {
                    ...this.expandedCriteria,
                    [nodeId]: true
                }
            } else {
                this.expandedCriteria = {
                    ...this.expandedCriteria,
                    [nodeId]: false
                }
            }
        },
        displayAllTags(nodeId) {
            const _areCriterionTagsAllDisplayed = get(this.expandedCriteria, `${nodeId}`, null)
            return _areCriterionTagsAllDisplayed
        },
        hasSmartSegments(criterion) {
            return !isEmpty(criterion.smartSegmentIds)
        },
        showId(criterion, criteriaType) {
            const restrictedTypes = ['Campaign', 'Conversion']
            return includes(restrictedTypes, criterion.jsonKey.type) ? false : !isNil(find(this.displayIds, id => id === criteriaType))
        },
        criterionId(criterion) {
            const restrictedSubtype = ['media_media_campain_clicked', 'media_media_campain_exposed']
            if (includes(MEDIA_CONVERSION_TYPE, criterion.jsonKey.type)) return last(criterion.id)
            else if (includes(MEDIA_CAMPAIGN_TYPE, criterion.jsonKey.type)) {
                if (includes(restrictedSubtype, criterion.jsonKey.subType)) return null
                return criterion.jsonKey.subType === 'project_campaign' ? last(criterion.id) : head(criterion.id)
            }
            return criterion.id
        },
        criterionPath(criterion) {
            const arrayAncestors = []
            for (const ancestor of criterion.ancestors) {
                arrayAncestors.push(ancestor.label)
            }
            return join(arrayAncestors, ' // ')
        },
        toggleFullList(dataType) {
            this.fullList[dataType] = !this.fullList[dataType]
        },
        foldTaxonomies() {
            this.areFoldedNodes = true
        }
    }
}
</script>
